// extracted by mini-css-extract-plugin
export default {"container":"ProjectTab_container__smur5","tabContainer":"ProjectTab_tabContainer__+wMk4","chartContainer":"ProjectTab_chartContainer__TGYp-"};